import * as yup from 'yup';
import { getDataValidationSchema } from '../DataTab/validationSchema';
import { validationSchema as deviceAdvancedValidationSchema } from '../AdvancedTab/validationSchema';
import { TDeviceDialogType } from '../types';

export const useValidationSchema = (mode: TDeviceDialogType) => {
    if (mode === 'editMultiple') {
        return yup.object().shape({});
    }

    return yup.object().shape({
        data: getDataValidationSchema(mode),
        advanced: deviceAdvancedValidationSchema,
    });
};
